import React, { Component } from 'react';
// se precisar avisar mudanças de escopo use a ScopeToolTip
// import ScopeToolTip from '../../components/ToolTip';

import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { translate } from 'react-translate';
import CounterBall from '@components/CounterBall';
// Utils
import {
  hasCapabilities,
  validateCapability,
  handleNewEventMixPanel,
  isTenantBornlogic,
} from '@utils/helpers';

import * as S from './styles';
import { checkIfIsTradeView } from '../../utils/helpers';

class MainMenu extends Component {
  state = {
    showCITooltip: true,
    labelActionsMenu: 'Medias',
    actionsSidebar: [{ capability: 'MEDIA_APPROVAL', menu: 'Approvals/New' }],
  };

  getBudgetURLRules = (code) => `/${code}/Budget/Listing/Groups`;

  handleRoutes = (scope) => {
    const {
      props: {
        match: { params },
        authenticationReducer: { subDomain, businessTokenData },
      },
    } = this;

    const tenant = subDomain.sub_domain;

    if (scope === 'Dashboard') {
      return `/${params.code}/Dashboard`;
    }

    if (scope === 'Report') {
      return `/${params.code}/Report/Overview/Global`;
    }
    if (scope === 'Budget') {
      return this.getBudgetURLRules(params.code, tenant);
    }
    if (scope === 'Messages') {
      return `/${params.code}/Messages/Main`;
    }
    if (scope === 'Medias') {
      return `/${params.code}/Medias/${this.newActionMenuLabel()}`;
    }
    if (scope === 'Communication') {
      if (validateCapability(businessTokenData, 'GDTV_MANAGE')) {
        return `/${params.code}/Communication/GDTV`;
      }
      return `/${params.code}/Communication/Library`;
    }

    if (scope === 'TradeAds') {
      return `/${params.code}/TradeAds`;
    }

    if (scope === 'Planner') {
      return `/${params.code}/Planner`;
    }

    if (scope === 'Insights') {
      return `/${params.code}/Trade/Dashboard`;
    }

    if (scope === 'Tracking') {
      return `/${params.code}/Trade/Tracking`;
    }

    if (scope === 'TradeCI') {
      return `/${params.code}/CI`;
    }

    if (scope === 'CI') {
      return `/${params.code}/CI`;
    }
  };

  newActionMenuLabel = () => {
    const { state } = this;
    const {
      props: {
        authenticationReducer: { businessTokenData },
      },
    } = this;

    let menu = '';

    if (state.labelActionsMenu !== 'Medias') {
      menu = state.actionsSidebar.find((item) => item.capability === state.labelActionsMenu).menu;
    }

    if (validateCapability(businessTokenData, 'MEDIA_APPROVAL')) {
      return (menu = 'Approvals/New');
    }
    return menu;
  };

  validatePermission = () => {
    const {
      state,
      props: {
        authenticationReducer: { subDomain, businessTokenData },
      },
    } = this;
    const scopes = [];
    let isTradeView = false;

    const tenant = subDomain.sub_domain;

    const batchActions =
      validateCapability(businessTokenData, 'BATCH_PROMOTE') ||
      validateCapability(businessTokenData, 'BATCH_REPLICATE');

    const approval = validateCapability(businessTokenData, 'MEDIA_APPROVAL');

    if (batchActions && approval && approval.is_main_capability) {
      scopes.push('Medias');

      const actionsSidebarItens = validateCapability(businessTokenData, 'MEDIA_APPROVAL');

      if (actionsSidebarItens.length === 1 && state.labelActionsMenu === 'Medias') {
        this.setState({
          labelActionsMenu: actionsSidebarItens[0].name,
        });
      }
    }

    if (checkIfIsTradeView()) {
      isTradeView = true;
    }

    if (isTradeView) {
      if (isTenantBornlogic()) {
        scopes.push('Tracking');
      } else {
        scopes.push('Insights');
      }
      scopes.push('TradeCI');
      return scopes;
    }

    if (!validateCapability(businessTokenData, 'TRADE_ADS_INDUSTRY')) {
      if (validateCapability(businessTokenData, 'DASHBOARD')) {
        scopes.push('Dashboard');
      }
      if (validateCapability(businessTokenData, 'REPORT')) {
        scopes.push('Report');
      }
      if (validateCapability(businessTokenData, 'ADACCOUNT_BUDGET')) {
        scopes.push('Budget');
      }
      if (validateCapability(businessTokenData, 'MEDIA_SETS')) {
        scopes.push('CI');
      }
      const feed = validateCapability(businessTokenData, 'FEED');

      if (batchActions || (approval && !approval.is_main_capability) || feed) {
        scopes.push('Medias');

        const actionsSidebarItens =
          validateCapability(businessTokenData, 'BATCH_REPLICATE') ||
          validateCapability(businessTokenData, 'BATCH_PROMOTE') ||
          validateCapability(businessTokenData, 'MEDIA_APPROVAL');

        if (actionsSidebarItens.length === 1 && state.labelActionsMenu === 'Medias') {
          this.setState({
            labelActionsMenu: actionsSidebarItens[0].name,
          });
        }
      }
      if (validateCapability(businessTokenData, 'MEDIA_SETS')) {
        scopes.push('Communication');
      }
    }

    if (validateCapability(businessTokenData, 'TRADE_ADS_INDUSTRY')) {
      scopes.push('TradeAds');
    }

    scopes.push('Planner');

    return scopes;
  };
  isTherePinnedAssetsCapability = (businessTokenData) =>
    validateCapability(businessTokenData, 'BATCH_PROMOTE') ||
    validateCapability(businessTokenData, 'BATCH_REPLICATE') ||
    validateCapability(businessTokenData, 'MEDIA_APPROVAL');

  logEvent = (scope) => {
    const verifyScope = (scope) => {
      if (scope === 'Report') {
        return 'click_report_main_menu';
      }
      if (scope === 'Budget') {
        return 'click_budget_main_menu';
      }
      if (scope === 'Messages') {
        return null;
      }
      if (scope === 'Medias') {
        return 'click_actions_main_menu';
      }
      if (scope === 'Communication') {
        return 'click_medias_main_menu';
      }
      if (scope === 'TradeAds') {
        return 'click_tradeads_main_menu';
      }

      if (scope === 'Planner') {
        return 'click_planner_main_menu';
      }
    };

    if (verifyScope(scope)) {
      handleNewEventMixPanel(
        verifyScope(scope),
        'view',
        this.props.authenticationReducer,
        this.props.match
      );
    }
  };

  renderOptions = () => {
    const {
      props: {
        t,
        location: { pathname, search },
        authenticationReducer: { subDomain, businessTokenData },
      },
    } = this;

    let counter = null;
    let scopes = [];
    let menu = null;

    if (counter) {
      menu = <CounterBall counter={counter} backgroundColor="blue2" alignTop />;
    }

    if (hasCapabilities(businessTokenData)) {
      scopes = [...this.validatePermission()];
    }

    return scopes.map((scope, index) => (
      <S.MainMenuItem
        key={index}
        currentTitle={scope}
        active={pathname}
        isBornlogic={subDomain?.sub_domain === 'bornlogic'}
      >
        <S.MainMenuLink
          onClick={() => this.logEvent(scope)}
          to={{
            pathname: this.handleRoutes(scope),
            search,
          }}
        >
          {scope === 'Medias' ? (
            <>
              <h6>{t('Medias')}</h6>
              {this.isTherePinnedAssetsCapability(businessTokenData) && <>{menu}</>}
            </>
          ) : (
            <h6>{t(scope)}</h6>
          )}
        </S.MainMenuLink>
      </S.MainMenuItem>
    ));
  };

  render() {
    return (
      <S.MainMenuWrapper>
        <S.MainMenuList>{this.renderOptions()}</S.MainMenuList>
      </S.MainMenuWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    actionsReducer: state.actionsReducer,
    authenticationReducer: state.authenticationReducer,
  };
}

export default withRouter(connect(mapStateToProps)(translate('MainMenu')(MainMenu)));
